import {
  createFrontendPlugin,
  PageBlueprint,
  ApiBlueprint,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import StorageIcon from '@material-ui/icons/Storage';
import { rdsAdminApiRef, RdsAdminApiClient } from './api';

const rdsAdminPage = PageBlueprint.make({
  name: 'rds-admin',
  params: {
    path: '/rds-admin',
    title: 'Bases de données',
    loader: () =>
      import('./components/RdsAdminPage/RdsAdminPage').then(m => (
        <m.RdsAdminPage />
      )),
  },
});

const rdsAdminApi = ApiBlueprint.make({
  name: 'rds-admin',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: rdsAdminApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) =>
          new RdsAdminApiClient(discoveryApi, fetchApi),
      }),
    ),
});

export default createFrontendPlugin({
  pluginId: 'rds-admin',
  // Header icon of pages without their own: same as the sidebar entry
  icon: <StorageIcon fontSize="inherit" />,
  extensions: [rdsAdminPage, rdsAdminApi],
});
